import { IconWrapper } from '../runtime';
export default IconWrapper('audio_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M13.5937 11.2022V3.65625L5.15625 5.87059V11.3859C5.02629 11.4032 4.89471 11.4328 4.76352 11.4754C3.8267 11.7798 3.26454 12.6337 3.50789 13.3827C3.75123 14.1317 4.70793 14.492 5.64475 14.1876C6.18527 14.012 6.60106 13.6535 6.80938 13.2377C6.95181 12.9684 7.0316 12.6591 7.0316 12.3275C7.03148 12.327 7.03136 12.3265 7.03124 12.3259V7.31701L11.7187 6.08682V10.2608C11.5887 10.2781 11.457 10.3077 11.3257 10.3504C10.3889 10.6548 9.82669 11.5087 10.07 12.2577C10.3134 13.0066 11.2701 13.367 12.2069 13.0626C12.7474 12.887 13.1632 12.5284 13.3715 12.1126C13.514 11.8434 13.5937 11.534 13.5937 11.2024V11.2022Z",
      "fill": "white"
    }
  })]);
});